import { CustomDialog } from '@/components/dialogs/custom-dialog'
import { FileViewer } from '@/components/dialogs/file-preview'

export function FilePreviewDialog({ open, onClose, url }: { open: boolean; onClose: () => void; url: string }) {
  return (
    <CustomDialog open={open} onClose={onClose} title="Visualizar arquivo" className="min-w-[1200px] h-auto" persistent={true} confirmationBeforeClose={false}>
      <div className="flex flex-col items-center justify-center">
        <FileViewer url={url} />
      </div>
    </CustomDialog>
  )
}
